import React, { useState } from 'react';
import { isEqual } from 'lodash';
import ascendingIcon from '../../../images/icons/sort-ascend.svg';
import descendingIcon from '../../../images/icons/sort-descend.svg';

import DropdownWrapper from './dropdown-wrapper';

import './split-sort-dropdown.scss';

const SplitSortDropdown = ({
	sortOptions, sortBy, setSortBy, parentDirection, setParentDirection,
}) => {
	const [selectedItem, setSelectedItem] = useState(sortBy);

	function handleSelectItem(idx, e) {
		e.stopPropagation();
		setSelectedItem(sortOptions[idx]);
	}

	function handleSetDirection(direction) {
		setParentDirection(direction);
		setSortBy(selectedItem);
	}

	const labelImageUrl = parentDirection === 'asc'
		? ascendingIcon
		: descendingIcon;

	return (
		<DropdownWrapper label={sortBy.label} labelImageUrl={labelImageUrl}>
			<div className="split-sort-dropdown">
				<div className="dropdown-header">Sort By:</div>
				{sortOptions.map((item, idx) => {
					const itemLabel = item.label.split(' ')[0].toLowerCase();

					return (
						<li key={idx}
							className={`dropdown-item ${itemLabel} ${isEqual(selectedItem, item) ? 'selected' : ''}`}
							onClick={(e) => handleSelectItem(idx, e)}>
							<span className="icon"><span className={`fill ${itemLabel}`}></span></span>
							<span className="dropdown-item-label">{item.label}</span>
						</li>
					);
				})}
				<div className="direction">
					<div className="ascending" onClick={(e) => handleSetDirection('asc', e)}>
						<span>Ascending</span>
						<img alt="ascending" src={ascendingIcon} />
					</div>
					<div className="descending" onClick={(e) => handleSetDirection('desc', e)}>
						<span>Descending</span>
						<img alt="descending" src={descendingIcon} />
					</div>
				</div>
			</div>
		</DropdownWrapper>
	);
};

export default SplitSortDropdown;
